export const MainConfig = {
    AppDetails: {
        app_name: "PerforMarket Booking", 
        app_description: "PerforMarket booking app",
        app_identifier: "uk.co.performarket.app",
        ios_app_version: "1.0.0", 
        android_app_version: 100
    },
    FirebaseConfig: {
        apiKey: "AIzaSyCO6wdJFymi4Tiz_qwJ_GUzBW_P7zKqFiw",
        authDomain: "performarket-booking.firebaseapp.com",
        databaseURL: "https://performarket-booking-default-rtdb.firebaseio.com",
        projectId: "performarket-booking",
        storageBucket: "performarket-booking.appspot.com",
        messagingSenderId: "284588154202",
        appId: "1:284588154202:web:fd5ee9d4a23e5b3313a763",
        measurementId: "G-GEZRSWWJMZ"
    },
    Google_Map_Key: "AIzaSyAU6HY2QBpygnGYysPuMa__omyabW99UcA",
    facebookAppId: "12345",
    PurchaseDetails: {
        CodeCanyon_Purchase_Code: "96a22ad6-811d-412a-8584-89f29b368ef0",
        Buyer_Email_Address: "inexxus@icloud.com"
    }
}